import React from "react";
import { ToastContainer } from "react-toastify";
import ViewNotifyUser from "../../components/Requests/NotifyUser/ViewNotifyUser";

export const ViewNotifyUserPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewNotifyUser />
        </div>
      </div>
    </div>
  );
};
